import React from "react";
import {makeAutoObservable} from "mobx";
import {DisposeUtils} from "../utils/DisposeUtils";
import {AuthStore} from "./AuthStore";

export const AppContext = React.createContext<AppStore | undefined>(undefined);

export class AppStore {
  private disposer = new DisposeUtils();

  auth: AuthStore;

  // Global confirmation dialog
  confirmationDialogText?: string = undefined;
  confirmationDialogContent?: any = undefined;
  confirmationDialogAction?: () => void = undefined;

  get socketApi() {
    return this.auth.socketApi;
  }

  get socketApiConnectedAndAuthenticated() {
    return (async () => {
      console.log("Waiting for Socket API connection and authentication...");
      await this.socketApi.connection.whenConnected;
      await this.socketApi.whenAuthenticated;
      console.log("Socket API connected and authenticated");
    })();
  }

  get api() {
    return this.auth.api;
  }

  constructor() {
    makeAutoObservable(this);
    this.auth = new AuthStore();
  }

  dispose() {
    this.disposer.dispose();
  }
}